import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { getAccounts } from "../../pages/admin/Allaccounts";
import Pagination from 'react-bootstrap/Pagination';

const SellerId = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const [sellers, setSellers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(7);
  const [totalPages, setTotalPages] = useState(1);
  const [distributorData, setDistributorData] = useState([]);

  useEffect(() => {
    fetchDistributorData();
  }, []);

  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const fetchDistributorData = async () => {
    try {
      const accounts = await getAccounts(token);
      const distributor = accounts.accounts?.filter(
        (account) => account.userType === "distributor"
      );
      setDistributorData(distributor);
      const sellerInfo = distributor.map((product) => ({
        id: product.id,
        referral_code: product.referral_code,
        email: product.email,
      }));

      const uniqueSellers = Array.from(
        new Set(sellerInfo.map((a) => a.id))
      ).map((id) => sellerInfo.find((a) => a.id === id));

      setSellers(uniqueSellers); // Store sellers
      setTotalPages(Math.ceil(uniqueSellers.length / itemsPerPage)); // Update total pages AFTER setting sellers
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    const pages = Math.max(1, Math.ceil(sellers.length / itemsPerPage));
    setTotalPages(pages);
  }, [sellers, itemsPerPage]);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const sellersId = Array.isArray(sellers)
    ? sellers.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const renderPaginationItems = () => {
    const items = [];

    items.push(
      <Pagination.Item
        key={1}
        active={currentPage === 1}
        onClick={() => handlePageClick(1)}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    for (let page = currentPage - 1; page <= currentPage + 1; page++) {
      if (page > 1 && page < totalPages) {
        items.push(
          <Pagination.Item
            key={page}
            active={currentPage === page}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </Pagination.Item>
        );
      }
    }

    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0 bg-dark">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-12">
              <h5>All Seller Ids</h5>
            </div>
            <div className="col-12 mt-5">
              <Table striped bordered hover responsive="sm">
                <thead className="text-center">
                  <tr>
                    <th>ID</th>
                    <th>Referral Code</th>
                    <th>Email</th>
                    <th className="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    sellersId.length > 0
                      ?
                      sellersId.map((seller, index) => {
                        const id = (currentPage - 1) * itemsPerPage + index + 1;
                        return (
                          <tr key={index}>
                            {/* <td>{index + 1}</td> */}
                            <td>{id}</td>
                            <td>{seller.referral_code}</td>
                            <td>{seller.email}</td>
                            <td className="text-center">
                              <Link
                                to={`/allsellerorderlist/${seller.id}`} // Pass only uid
                                className="btn btn-outline-dark"
                              >
                                <Icon.ArrowRight />
                              </Link>
                            </td>
                          </tr>
                        );
                      })
                      :
                      <tr>
                        <td colSpan="4" className="text-center p-5">
                          <span>No Saller Has Order Yet</span>
                        </td>
                      </tr>
                  }
                </tbody>
              </Table>
            </div>

            {/* Pagination controls */}
            {
              sellersId.length > 0 &&
              <div className="d-flex justify-content-center mt-2">
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageClick(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  />
                  {renderPaginationItems()}
                  <Pagination.Next
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageClick(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            }
            {/* Pagination end */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerId;
